interface PathProps {
    d?: string;
    children: React.ReactElement<PathProps>[];
}

const svgrToPaths = (target: React.ReactElement<PathProps>) => {
    const paths: string[] = [];
    const extractPath = (el: React.ReactElement<PathProps>) => {
        if (el?.props?.d) {
            paths.push(el.props.d);
        }
        if (el?.props?.children && el?.type !== 'clipPath') {
            if (Array.isArray(el.props?.children)) {
                el.props.children.forEach((child) => {
                    extractPath(child);
                });
            } else {
                extractPath(el.props.children);
            }
        }
    };
    extractPath(target);

    return paths;
};

export default svgrToPaths;
